export default {
  warnings: [
    {
      text: 'Копирование материалов запрещено',
    },
    {
      text: 'Издание может получать комиссию от покупки товаров, размещённых в публикациях',
    },
  ],
};
